var _rect, _g, _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _rect2, _circle6, _circle7, _rect3, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyref(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 347,
    viewBox: "0 0 384 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4989_45292",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 384,
    height: 331
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.699951,
    y: 0.796875,
    width: 382.6,
    height: 329.508,
    rx: 16,
    fill: "url(#paint0_linear_4989_45292)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4989_45292)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16.0828,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9172,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.917,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4989_45292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.167,
    y: -1.59375,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.917,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 139.917,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.917,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4989_45292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.167,
    y: -1.59375,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.917,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 256.917,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.917,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.917,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.8328,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.1672,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.1672,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.167,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.167,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.167,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.917,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.917,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4989_45292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.167,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.917,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 334.917,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.917,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4989_45292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 373.167,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.917,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: -16.0828,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9172,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.9172,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_4989_45292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.1672,
    y: 76.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.9172,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.917,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.917,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_4989_45292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.167,
    y: 76.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.917,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.917,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.917,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.917,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9172,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.917,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.917,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.917,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.917,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.917,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_4989_45292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.1672,
    y: 154.406,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.9172,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.917,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.917,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.917,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.917,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.917,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.0828,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.1672,
    y: 193.406,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.917,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.917,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.917,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.917,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.917,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.917,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.917,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9172,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.9172,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.917,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.917,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.917,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.917,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.917,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.917,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.917,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.917,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.0828,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9172,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.9172,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.917,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.917,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.917,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.917,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.917,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.917,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.917,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.917,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.0828,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9172,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.9172,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.917,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.917,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.917,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.917,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.917,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.917,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.917,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.917,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 199.478,
    cy: 179.162,
    r: 71.103,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.525 162.387L277.216 181.207L270.261 255.263L190.477 235.215L210.525 162.387Z",
    fill: "#D2D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.807 180.799L206.843 162.797C203.433 167.707 194.65 180.39 186.795 191.846C178.939 203.302 165.246 217.35 159.382 222.941L241.211 247.081C242.712 246.263 249.067 240.289 262.487 222.941C275.907 205.594 277.625 187.618 276.807 180.799Z",
    fill: "#F3F3F3",
    stroke: "#CCCCCC",
    strokeWidth: 0.818293
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.98,
    cy: 182.027,
    r: 3.27317,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.161,
    cy: 199.211,
    r: 3.27317,
    fill: "#C4C4C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.341,
    cy: 214.758,
    r: 3.27317,
    fill: "#C4C4C4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.216,
    cy: 144.866,
    r: 29.8586,
    transform: "rotate(25.8347 147.216 144.866)",
    fill: "#F0F0F0",
    stroke: "#D2D2D2",
    strokeWidth: 0.818293
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16.3659,
    height: 2.45488,
    transform: "matrix(1 0 0 -1 137.806 153.457)",
    fill: "#C4C4C4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.032,
    cy: 139.958,
    r: 4.50061,
    fill: "#C4C4C4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.946,
    cy: 139.958,
    r: 4.50061,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 211.524,
    y: 202.035,
    width: 39.2781,
    height: 1.63659,
    rx: 0.818293,
    transform: "rotate(15.5 211.524 202.035)",
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 202.957,
    y: 218.617,
    width: 35.5522,
    height: 1.63659,
    rx: 0.818293,
    transform: "rotate(15.5 202.957 218.617)",
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 222.306,
    y: 184.52,
    width: 39.2781,
    height: 1.63659,
    rx: 0.818293,
    transform: "rotate(14.5 222.306 184.52)",
    fill: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4989_45292",
    x: 98.1672,
    y: -3.59375,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4989_45292"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4989_45292",
    x: 215.167,
    y: -3.59375,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4989_45292"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4989_45292",
    x: 293.167,
    y: 35.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4989_45292"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4989_45292",
    x: 371.167,
    y: 35.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4989_45292"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_4989_45292",
    x: 59.1672,
    y: 74.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4989_45292"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_4989_45292",
    x: 137.167,
    y: 74.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4989_45292"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_4989_45292",
    x: 59.1672,
    y: 152.406,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4989_45292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4989_45292",
    x1: 192,
    y1: 208.213,
    x2: 192,
    y2: 330.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyref);
export default __webpack_public_path__ + "static/media/emptyref.f9a862d1693453a0cea4000296c06008.svg";
export { ForwardRef as ReactComponent };